import { Box, LinearProgress, LinearProgressProps } from "@mui/material";
import { Signal, useSignal } from "@preact/signals-react";
import { FlexProperties, LinearProgressVariant, Maybe, StyleProperties } from "../../../resolvers-types";
import { INGLinearProgressProps, RuntimeContext } from "../../library/NGFieldExtensions";
import { setupLocalState } from "../../library/dataService";
import { getTypename } from "../../library/metadataUtils";
import { getClassName, getsxObject, getTestId } from "../../library/utils";

interface LocalState {
  config: LinearProgressProps;

  Classes: Signal<string[]>;
  Style: Signal<Maybe<StyleProperties> | Maybe<FlexProperties> | undefined>;
  Value: Signal<number>;
  ValueBuffer: Signal<number>;
  Variant: Signal<LinearProgressVariant>;
  Visible: Signal<boolean>;

  context: RuntimeContext;
}

export function NGLinearProgress({ config, context }: INGLinearProgressProps) {
  // local state
  const local: LocalState = setupLocalState(
    config,
    {
      Classes: useSignal(config.Classes ?? []),
      Style: useSignal(config.Style ?? {}),
      Value: useSignal(config.Value),
      ValueBuffer: useSignal(config.ValueBuffer),
      Variant: useSignal<LinearProgressVariant>(config.Variant ?? LinearProgressVariant.Indeterminate),
      Visible: useSignal(config.Visible ?? true),
    },
    context
  );

  // variables
  const className = getClassName(local.Classes) || "color-primary";

  // render
  return local.Visible.value ? (
    <Box sx={{ width: "100%" }}>
      <LinearProgress
        data-testid={getTestId(config)}
        data-type={getTypename(config)}
        className={className}
        color="inherit"
        sx={getsxObject(local.Style.value)}
        value={local.Value.value}
        valueBuffer={local.ValueBuffer.value}
        variant={local.Variant.value}
      />
    </Box>
  ) : null;
}
